export default "/react/logoSpyWords-173bcf16.png";